import { IPersonalManager, TImageSize } from './types';
import camila1x from './assets/camila1x.png';
import camila2x from './assets/camila2x.png';
import zaria1x from './assets/zaria1x.png';
import zaria2x from './assets/zaria2x.png';
import anastasia1x from './assets/anastasia1x.png';
import anastasia2x from './assets/anastasia2x.png';
import rufina1x from './assets/rufina1x.png';
import rufina2x from './assets/rufina2x.png';
import lyaisan1x from './assets/lyaisan1x.png';
import lyaisan2x from './assets/lyaisan2x.png';

export const PERSONAL_MANAGERS: IPersonalManager[] = [
  {
    name: 'Камила',
    image: {
      x1: camila1x,
      x2: camila2x,
    },
  },
  {
    name: 'Зария',
    image: {
      x1: zaria1x,
      x2: zaria2x,
    },
  },
  {
    name: 'Анастасия',
    image: {
      x1: anastasia1x,
      x2: anastasia2x,
    },
  },
  {
    name: 'Руфина',
    image: {
      x1: rufina1x,
      x2: rufina2x,
    },
  },
  {
    name: 'Ляйсан',
    image: {
      x1: lyaisan1x,
      x2: lyaisan2x,
    },
  },
];

export const IMAGE_SIZE: TImageSize = {
  phone: 100,
  tablet: 160,
  desktop: 220,
};
